<template>
  <FlexColumn>
    <Label bold text="学歴" />
    <FlexRow wrap>
      <Label :text="applicant.academic.schoolName" />
      <Label :text="applicant.academic.schoolDepartment" />
      <Label :text="applicant.academic.schoolDepartmentDetail" />
      <Label v-if="applicant.academic.graduatedYear" :text="`${applicant.academic.graduatedYear}年卒業`" />
    </FlexRow>
  </FlexColumn>
</template>

<script>
import FlexColumn from "@/components/atoms/FlexColumn";
import Label from "@/components/atoms/Label";
import FlexRow from "@/components/atoms/FlexRow";
export default {
  name: "ApplicantAcademicHistory",
  components: {FlexRow, Label, FlexColumn},
  props: {
    applicant: {
      type: Object
    }
  }
}
</script>

<style scoped>

</style>